<template>
  <div id="ViewerContainer" ref="ViewerContainer">
    <div
      id="ViewerWrapper"
      ref="ViewerWrapper"
      class="col-12 text-center"
      :class="{ hidden: show !== true }"
    >
      <div
        id="ViewerLoader"
        :class="{ sticky: config.visualMode === 'conf' }"
        ref="ViewerLoader"
        class="col-12"
      >
        <img
          :src="appUrl + '/img/assets/spinner.svg'"
          width="100"
          height="auto"
          alt="Loading"
        />
      </div>
      <canvas
        v-if="!this.isSet"
        class="item-pic"
        :class="{
          sticky: config.visualMode === 'conf',
          images: config.visualMode === 'images',
          show: config.visualMode === 'show',
        }"
        ref="JewelleryViewer3d"
        id="JewelleryViewer3d"
      >
      </canvas>
      <canvas
        v-if="this.isSet"
        class="item-pic"
        :class="{
          sticky: config.visualMode === 'conf',
          images: config.visualMode === 'images',
          show: config.visualMode === 'show',
        }"
        ref="JewelleryViewer3dSet"
        id="JewelleryViewer3dSet"
      >
      </canvas>
      <div
        v-if="
          isTryOnPossible() && (parseInt(currentItem) > -1 || items.length < 2)
        "
        @click="toggleTryOn()"
        id="tryOnMenu"
        class="text-end"
      >
        <i
          class="fas fa-hand-paper"
          :class="{
            sticky: config.visualMode === 'conf',
            images: config.visualMode === 'images',
            show: config.visualMode === 'show',
            'try-on': isTryOnStarted(),
          }"
          id="tryOn"
        >
          <span class="try-on-note">TryOn</span>
        </i>
      </div>
    </div>
    <div class="col-12">
      <p class="viewer-notification text-center" :class="config.visualMode">
        <span v-if="!isTryOnStarted()">{{
          $t("Notifications.variations")
        }}</span>
        <template v-else>
          <span
            @click="switchFinger()"
            id="switchFinger"
            style="padding-left: 1.5rem"
          >
            <i class="fas fa-hand-paper"></i>
            {{ $t("TryOn.changeFinger") }}
          </span>
          <span
            @click="toggleTryOn()"
            id="cancelTryOnLink"
            style="padding-left: 1.5rem"
          >
            {{ $t("TryOn.cancel") }}
          </span>
        </template>
      </p>
    </div>
  </div>
</template>

<script>
import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";
import JewelleryViewer3d from "@/assets/DAO/JewelleryViewer3d";
import MediaQuery from "@/assets/Helper/MediaQuery";

let canvas, canvasJewellery, currentCanvas, lastItem, lastItemData;
let isInit = true;

export default {
  name: "ImageViewer3d",
  data() {
    return {
      appEnv: Config.getters.getAppEnv,
      appUrl: Config.getters.getAppUrl,
      show: false,
      currentItem: SetData.getters.getCurrentItemId,
      showSetIn3d: SetData.getters.getShowSetIn3d,
      setId: "",
      isSet: false,
      config: Config.getters.getConfig,
      isDesktop: MediaQuery.isDesktop(),
      config3d: {},
    };
  },
  props: ["items"],
  updated() {
    if (!this.$parent["is3dViewerAllowed"]()) {
      return;
    }
    currentCanvas = this.isSet ? canvasJewellery : canvas;

    if (currentCanvas) {
      currentCanvas.className = "item-pic";
      if (this.config.visualMode === "images") {
        currentCanvas.className = "item-pic images";

        this.restoreCanvas();
        this.hideLoader();
      }

      if (this.config.visualMode === "conf") {
        currentCanvas.className = "item-pic sticky";

        this.restoreCanvas();

        setTimeout(() => {
          this.show = true;
          this.$parent.$parent.$parent["hideImage"][
            this.items.length < 2 ? "overview" : this.currentItem
          ] = true;
        });
      } else if (this.config.visualMode === "show") {
        currentCanvas.className = "item-pic show";
        this.restoreCanvas();
      }
    }
  },
  mounted() {
    currentCanvas = this.isSet ? canvasJewellery : canvas;

    this.init();

    this.$root.$on("updateViewer", () => {
      if (isInit === false) {
        this.getData();
      }
    });
    this.$root.$on("hideLoader3D", () => {
      this.hideLoader();
    });
    this.$root.$on("toggleTryOn", () => {
      this.toggleTryOn();
    });
  },
  beforeDestroy() {
    this.$root.$off("hideLoader3D");
    this.$root.$off("updateViewer");
    this.$root.$off("toggleTryOn");
  },
  methods: {
    isTryOnPossible: function () {
      if (this.isSet || this.$parent["isJewelleryBut3dConfigurator"]()) {
        return false;
      }

      try {
        return navigator.mediaDevices.enumerateDevices().then((devices) => {
          return devices.some((device) => device.kind === "videoinput");
        });
      } catch (error) {
        return false;
      }
    },
    switchFinger: function () {
      const Event = new KeyboardEvent("keydown", { key: "a" });
      document.dispatchEvent(Event);
    },
    toggleTryOn: function () {
      const viewerControls = document.getElementById("jewelleryViewerControls");
      const Viewer3D = this.isSet
        ? this.$parent.$parent.$parent["Viewer3dSet"]
        : this.$parent.$parent.$parent["Viewer3d"];

      if (Viewer3D["isTryOnRunning"]()) {
        if (viewerControls) {
          viewerControls.classList.remove("hidden");
        }
        this.$parent.$data.show2dIcon = true;
        this.$parent.$data.showWishlistIcon = true;
        this.$parent.$data.showAddonList = true;
        this.$parent.$data.showMagnifierIcon = true;
        Viewer3D["stopTryOn"]();
      } else {
        Viewer3D["startTryOn"]();

        if (viewerControls) {
          viewerControls.classList.add("hidden");
        }
        this.$parent.$data.show2dIcon = false;
        this.$parent.$data.showWishlistIcon = false;
        this.$parent.$data.showAddonList = false;
        this.$parent.$data.showMagnifierIcon = false;
      }
    },
    isTryOnStarted: function () {
      const Viewer3D = this.isSet
        ? this.$parent.$parent.$parent["Viewer3dSet"]
        : this.$parent.$parent.$parent["Viewer3d"];
      if (Viewer3D) {
        return Viewer3D["isTryOnStarted"]();
      }
      return false;
    },
    setHeight: function () {
      let heightWithoutSideMenu = "54rem";

      if (canvas) {
        canvas.style.height = !this.config.showSideMenu
          ? heightWithoutSideMenu
          : "";
      }
      if (canvasJewellery) {
        canvasJewellery.style.height = !this.config.showSideMenu
          ? heightWithoutSideMenu
          : "";
      }

      if (this.$refs.JewelleryViewer3dSet) {
        this.$refs.JewelleryViewer3dSet.style.height = !this.config.showSideMenu
          ? heightWithoutSideMenu
          : "";
      }
      if (this.$refs.JewelleryViewer3d) {
        this.$refs.JewelleryViewer3d.style.height = !this.config.showSideMenu
          ? heightWithoutSideMenu
          : "";
      }
    },
    init: function () {
      if (!this.$parent["is3dViewerAllowed"]()) {
        return;
      }

      this.getData();
    },
    getData: function () {
      this.setHeight();

      this.show = true;

      if (
        this.items[this.currentItem] &&
        this.items[this.currentItem].description.jewelleryType > 0 &&
        !this.$parent["isJewelleryBut3dConfigurator"]()
      ) {
        this.setId = this.items[this.currentItem].description.setId;
      }

      this.isSet = this.showSetIn3d[this.setId] ?? false;
      if (!this.isSet && this.setId !== "") {
        return;
      }

      let description3d = [];
      if (SetData.getters.getDescription3d.length > 0) {
        if (SetData.getters.getDescription3d[this.currentItem]) {
          description3d = [SetData.getters.getDescription3d[this.currentItem]];
        } else {
          description3d = SetData.getters.getDescription3d;
        }
      }

      if (description3d.length < 1) {
        let items = this.items;

        if (items.length > 0) {
          JewelleryViewer3d.getData(items, this.currentItem).then(
            (response) => {
              let viewerData;

              if (!isNaN(this.currentItem)) {
                viewerData = {
                  items: [response.result.items[this.currentItem]],
                };
              } else {
                viewerData = response.result;
              }

              isInit === true
                ? this.initViewer(viewerData)
                : this.updateViewer(viewerData);
            }
          );
        }
      } else {
        this.initViewer({ items: description3d }, true);
      }
    },
    initConfig: function () {
      this.config3d = {
        env: Config.getters.getAppEnv,
        language: Config.getters.getLanguage,
        country: Config.getters.getCountry,
        model: {
          src: "",
          type: 0,
          baseSet:
            this.isSet === true ? JewelleryViewer3d.getBaseSet(this.setId) : "",
          filename:
            this.isSet === true
              ? JewelleryViewer3d.getBaseSet(this.setId) + ".gltf"
              : "",
        },
        configurator: this.isSet !== true,
        isConfiguratorEnv: true,
        jewelleryViewer: null,
        jewelleryType: null,
        wrapper: this.$refs.ViewerWrapper,
        loaderNode: this.$refs.ViewerLoader,
        controls: true,
      };

      this.config3d.jewelleryType = this.items[this.currentItem]
        ? this.items[this.currentItem].description.jewelleryType
        : this.items[0].description.jewelleryType;
      this.config3d.model.type = this.config3d.jewelleryType ?? 0;
    },
    initViewer: function (description3d, onlyRestore = false) {
      if (this.$refs.ViewerWrapper) {
        this.initConfig();

        description3d = this.getEngraving(description3d);
        this.config3d.jewelleryViewer = description3d;

        if (this.$parent.$parent.$parent["Viewer3d"] == null && !this.isSet) {
          canvas =
            this.$refs.JewelleryViewer3d ?? this.$refs.JewelleryViewer3dSet;
          currentCanvas = canvas;

          JewelleryViewer3d.loadViewer().then(() => {
            // eslint-disable-next-line no-undef
            this.$parent.$parent.$parent["Viewer3d"] = new PLUGIN.Plugin(
              { canvas: currentCanvas },
              this.config3d
            );

            isInit = false;
          });
        } else if (
          this.$parent.$parent.$parent["Viewer3dSet"] == null &&
          this.isSet
        ) {
          canvasJewellery =
            this.$refs.JewelleryViewer3dSet ?? this.$refs.JewelleryViewer3d;
          currentCanvas = canvasJewellery;

          JewelleryViewer3d.loadViewer().then(() => {
            // eslint-disable-next-line no-undef
            this.$parent.$parent.$parent["Viewer3dSet"] = new PLUGIN.Plugin(
              { canvas: currentCanvas },
              this.config3d
            );

            isInit = false;
          });
        } else {
          if (this.isSet) {
            const Viewer3D = this.$parent.$parent.$parent["Viewer3dSet"];
            if (Viewer3D && typeof Viewer3D["enableControls"] == "function") {
              Viewer3D["enableControls"](this.config3d);
              Viewer3D["resetPlay"]();
            }

            if (lastItem !== this.currentItem) {
              this.showLoader();
              Viewer3D["switchViewer"](this.config3d);
            } else {
              this.hideLoader();
            }
          } else {
            currentCanvas = canvas;

            this.restoreCanvas();

            const Viewer3D = this.$parent.$parent.$parent["Viewer3d"];

            if (onlyRestore === false || lastItem !== this.currentItem) {
              if (typeof Viewer3D["switchViewer"] == "function") {
                if (this.isTryOnStarted()) {
                  this.toggleTryOn();
                }
                this.showLoader();

                if (this.isReinitializeViewer()) {
                  this.$parent.$parent.$parent["Viewer3d"] = null;
                  this.$parent.$parent.$parent["Viewer3dSet"] = null;
                  this.getData();
                } else {
                  Viewer3D["switchViewer"](this.config3d);
                }
              }
            } else {
              if (
                !this.$refs.ViewerWrapper.querySelector(
                  "#jewelleryViewerControls"
                )
              ) {
                if (
                  Viewer3D &&
                  typeof Viewer3D["enableControls"] == "function"
                ) {
                  Viewer3D["enableControls"](this.config3d);
                  setTimeout(() => {
                    if (this.isTryOnStarted()) {
                      const viewerControls = document.getElementById(
                        "jewelleryViewerControls"
                      );
                      if (viewerControls) {
                        viewerControls.classList.add("hidden");
                      }
                    }
                  });
                }
              }
              this.hideLoader();
            }
          }
        }

        this.show = true;
        lastItem = this.currentItem;
        lastItemData = this.items[this.currentItem];

        this.$nextTick(() => {
          if (this.$refs.ViewerWrapper) {
            //this.$refs.ViewerWrapper.scrollIntoView(false);
          }
        });
      }
    },
    updateViewer: function (data) {
      if (this.isReinitializeViewer()) {
        this.$parent.$parent.$parent["Viewer3d"] = null;
        this.$parent.$parent.$parent["Viewer3dSet"] = null;
        this.getData();
      } else {
        const Viewer3D = this.isSet
          ? this.$parent.$parent.$parent["Viewer3dSet"]
          : this.$parent.$parent.$parent["Viewer3d"];

        if (Viewer3D != null) {
          if (data != null && typeof data === "object") {
            this.initConfig();

            data = this.getEngraving(data);
            this.config3d.jewelleryViewer = data;

            this.restoreCanvas();

            if (typeof Viewer3D["updateViewer"] == "function") {
              this.showLoader();

              Viewer3D["updateViewer"](this.config3d);
            }
          }
        }
      }
    },
    restoreCanvas: function () {
      const searchCanvas = "#JewelleryViewer3d";
      const searchCanvasSet = "#JewelleryViewer3dSet";

      if (
        this.$refs.ViewerWrapper &&
        this.$refs.ViewerLoader &&
        currentCanvas
      ) {
        if (this.$refs.ViewerWrapper.querySelector(searchCanvas)) {
          this.$refs.ViewerWrapper.querySelector(searchCanvas).remove();
        }
        if (this.$refs.ViewerWrapper.querySelector(searchCanvasSet)) {
          this.$refs.ViewerWrapper.querySelector(searchCanvasSet).remove();
        }
        this.$refs.ViewerLoader.after(currentCanvas);
      }
    },
    hideLoader: function () {
      const Viewer3D = this.isSet
        ? this.$parent.$parent.$parent["Viewer3dSet"]
        : this.$parent.$parent.$parent["Viewer3d"];
      if (Viewer3D && typeof Viewer3D["hideLoader"] == "function") {
        Viewer3D["hideLoader"](this.config3d);
      }
    },
    showLoader: function () {
      const Viewer3D = this.isSet
        ? this.$parent.$parent.$parent["Viewer3dSet"]
        : this.$parent.$parent.$parent["Viewer3d"];
      if (Viewer3D && typeof Viewer3D["showLoader"] == "function") {
        Viewer3D["showLoader"](this.config3d);
      }
    },
    getEngraving: function (data) {
      if (
        data &&
        data.items &&
        data.items.length > 0 &&
        this.items &&
        this.items.length > 0 &&
        !this.isSafari() &&
        !this.isMobileSafari()
      ) {
        let engraving = {};
        if (!isNaN(this.currentItem)) {
          if (
            this.items[this.currentItem] &&
            this.items[this.currentItem]["engraving"]
          ) {
            engraving = this.items[this.currentItem]["engraving"];
          }
          data.items[0]["engraving"] = engraving;
        } else {
          for (let numericKey in data.items) {
            engraving = {};
            if (this.items[numericKey] && this.items[numericKey]["engraving"]) {
              engraving = this.items[numericKey]["engraving"];
            }
            data.items[numericKey]["engraving"] = engraving;
          }
        }
      }
      return data;
    },
    isReinitializeViewer: function () {
      if (
        lastItemData &&
        lastItemData.description &&
        lastItemData.description.possibleVariations &&
        this.items[this.currentItem] &&
        this.items[this.currentItem].description &&
        this.items[this.currentItem].description.possibleVariations &&
        ((lastItemData.description.jewelleryType > 0 &&
          this.items[this.currentItem].description.jewelleryType < 1) ||
          (lastItemData.description.jewelleryType < 1 &&
            this.items[this.currentItem].description.jewelleryType > 0) ||
          (lastItemData.description.possibleVariations.chainWidths &&
            !this.items[this.currentItem].description.possibleVariations
              .chainWidths) ||
          (!lastItemData.description.possibleVariations.chainWidths &&
            this.items[this.currentItem].description.possibleVariations
              .chainWidths))
      ) {
        return true;
      }
      return false;
    },
    isSafari: function () {
      return (
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
        navigator.vendor.includes("Apple") &&
        !window.MSStream
      );
    },
    isIOS: function () {
      return /iPad|iPhone|iPod/.test(navigator.userAgent);
    },
    isMobileSafari: function () {
      return this.isSafari() && this.isIOS();
    },
  },
  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#ViewerWrapper {
  position: relative;
  display: inline;
}

#ViewerContainer p.viewer-notification {
  color: var(--image-black);
  font-weight: bold;
  font-size: 0.9rem;
  letter-spacing: 0.1rem;
  padding: 1rem 1rem 2.5rem 1rem;
  border-top: 1px solid #cccccc;
  margin: 3rem 0 0 0;
}

#ViewerLoader {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  left: 0;
  top: -25rem;
  width: 100%;
}

.vm-conf {
  #ViewerLoader {
    top: -15rem;

    @media (min-width: 768px) {
      top: -25rem;
    }
  }
}

#JewelleryViewer3d,
#JewelleryViewer3dSet {
  width: 100%;
  height: 100%;
  touch-action: none;

  @media (max-width: 991px) {
    &.sticky {
      width: inherit;
      height: 27rem;

      @media (min-width: 768px) {
        height: 40rem;
      }
    }

    &.show {
      width: inherit;
      height: 25rem;

      @media (min-width: 375px) {
        height: 29rem;
      }

      @media (min-width: 425px) {
        height: 39rem;
      }
    }
  }

  @media (min-width: 992px) {
    height: 41rem;

    &.images {
      height: 100%;
      min-height: 60rem;
      max-height: 60rem;
    }
  }
}

#tryOnMenu {
  position: relative;

  #tryOn {
    position: absolute;
    cursor: pointer;
    color: rgb(85, 85, 85);
    font-size: 2rem;
    right: 0.5rem;
    z-index: 1;
    top: 1rem;

    &:before {
      @media (min-width: 375px) and (max-width: 413px) {
        display: none;
      }
    }

    &.try-on {
      color: $black;
    }

    &.images {
      top: -4rem;
    }

    .try-on-note {
      @media (max-width: 374px) {
        display: none;
      }
    }

    span {
      margin-left: 0.75rem;
      font-family: "Roboto", serif;
    }
  }
}

#cancelTryOnLink,
#switchFinger {
  font-size: 1.1rem;
  color: $black;
}

.vm-images {
  #tryOnMenu {
    #tryOn {
      right: 1rem;
    }
  }
}
</style>

<style lang="scss">
#jewelleryViewerControls {
  text-align: center !important;
  margin-top: 1rem;
  padding-bottom: 0 !important;

  @media (max-width: 991px) {
    padding-bottom: 1.5rem;
  }

  @media (min-width: 992px) {
    margin-top: 1rem;
  }
}

.vm-images {
  #jewelleryViewerControls {
    display: none;
    margin-top: 0;
  }
}

#handAnalyzingProgress {
  @media (max-width: 991px) {
    top: 20rem !important;
    left: 50% !important;
  }
}
</style>
